import script from "./RefGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./RefGuide.vue?vue&type=script&setup=true&lang=js"

import "./RefGuide.vue?vue&type=style&index=0&id=de6e8574&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de6e8574"]])

export default __exports__